import React from 'react';
import './Spinner.css';
import { KM220_LOADER_LOGO_SRC } from './km220LogoLoader';

export default function Spinner({ className = '', pageCentered = false }) {
  const loader = (
    <div
      id="spinnerBox"
      className={`km220-logo-loader ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <img
        className="km220-logo-loader__logo"
        src={KM220_LOADER_LOGO_SRC}
        alt=""
        width={96}
        height={96}
        decoding="async"
      />
    </div>
  );

  if (pageCentered) {
    return <div className="page-loader-overlay">{loader}</div>;
  }

  return loader;
}
